<script>
  import settings from '../../config';

  export let url = null;
  export let options;

  let not_existent_image_url = '//does-not-exist.jpg';
  let default_image_url = `${settings.api_host}/uploads/profile_images/default-avatar.jpg`;
  let image_url = `${settings.api_host}${url}`;
</script>

<object
  title="avatar"
  data={url ? image_url : not_existent_image_url}
  style="border-radius: 50%; "
  {...options}>
  <img
    src={default_image_url}
    alt="avatar"
    style="border-radius: 50%;"
    {...options} />
</object>

<style>
  .header-avatar {
    border-radius: 50%;
  }
</style>
